// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0aa228d9","977":"c58dcad9"}[chunkId] + ".chunk.js";
};